export interface CoachPlayersProfileTrainingsListFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  training_category_id: string;
  training_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    };
  };
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    date: string;
    fields: any;
  };
}

export class CoachPlayersProfileTrainingsListFormUpdate implements CoachPlayersProfileTrainingsListFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  training_category_id: string;
  training_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    };
  };
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    date: string;
    fields: any;
  };

  constructor() {
    this.id = "";
    this.user_id = "";
    this.organization_id = "";
    this.training_category_id = "";
    this.training_category = {
      id: "",
      content: {
        name: "",
        fields: [],
      },
    };
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
    this.content = {
      date: "",
      fields: [],
    };
  }
}